export default "__VITE_ASSET__CfflksZ8__"